/* eslint-disable react/prop-types */
import React from 'react';
import IcoMoon from 'react-icomoon';

const iconSet = require('./selection.json');

const Icon = ({...props}) => {
  return <IcoMoon iconSet={iconSet} {...props} icon={props.name} />;
};

// const Icon = ({ name, size, color }) => (
//   <Icon iconSet={iconSet} name={name} size={size} color={color} />
// );

export default Icon;
